import React from 'react';

import HeaderWidget from '../components/header-widget';

const HeaderWidgetApp = () => <HeaderWidget />;

export default HeaderWidgetApp;
